export function showMoreServices() {
    const servicesWrap = $(".services-search-results-wrap");
    const showMoreBtn = servicesWrap.find(".show-more-results .button");

    showMoreBtn.on("click", function (e) {
        e.preventDefault();
        servicesWrap.toggleClass('opened');
        if (servicesWrap.hasClass('opened')) {
            showMoreBtn.text('View less');
        } else {
            showMoreBtn.text('View more');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/showMoreServices.js